import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import DefaultLayout from './layouts/Default.vue'
import About from './views/About.vue'
import Map from './views/Map.vue'
import MapTest from './views/MapTest.vue'
import Temp from './views/Temp.vue'
import Login from './views/Login.vue'
import Journal from './views/Journal'
import WorkSummary from './views/WorkSummary'
import EventSummary from './views/EventSummary'
import Assign from './views/Assign'
import DefineWork from './views/DefineWork'
import User from './views/User'
import RepWorkTime from './layouts/Reports/RepWorkTime'
import EnterYield from './views/EnterYield'
import YieldJournal from './components/Yield/YieldJournal'
import CostBill from './layouts/Reports/CostBill'
import Signup from './views/Signup'
import ExcelAnalyse from './views/ExcelAnalyse'
import ExcelGeoWork from './views/ExcelGeoWork'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: DefaultLayout,
      children: [
        {
          path: '',
          name: 'journal',
          component: Journal,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/worksummary',
          name: 'WorkSummary',
          component: WorkSummary,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/eventsummary',
          name: 'EventSummary',
          component: EventSummary,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/assign',
          name: 'assign',
          component: Assign,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/user',
          name: 'user',
          component: User,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/definework',
          name: 'DefineWork',
          component: DefineWork,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/enteryield',
          name: 'EnterYield',
          component: EnterYield,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/yieldjournal',
          name: 'YieldYournal',
          component: YieldJournal,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/login',
          name: 'Login',
          component: Login,
        },
        {
          path: '/signup',
          name: 'Signup',
          component: Signup,
        },
        {
          path: '/about',
          name: 'about',
          component: About
        },
        {
          path: '/temp',
          name: 'Temp',
          component: Temp
        },
        {
          path: '/journal',
          name: 'Journal',
          component: Journal,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/map',
          name: 'Map',
          component: Map,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/rep_worktime/:repid',
          name: 'RepWorkTime',
          component: RepWorkTime,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/cost_bill/:repid',
          name: 'CostBill',
          component: CostBill,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/excelanalyse',
          name: 'ExcelAnalyse',
          component: ExcelAnalyse,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/excelgeowork',
          name: 'ExcelGeoWork',
          component: ExcelGeoWork,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        },
        {
          path: '/maptest',
          name: 'MapTest',
          component: MapTest,
          beforeEnter (to, from, next){
            Auth(to, from, next);
          }
        }
      ]
    }
  ]
})

function Auth(to, from, next){
  if(store.state.session){
    next();    
  }
  else{
    next({name: 'Login'}); 
  } 
}
